/**
 * Faster cart drawer open sitewide.
 * UpCart is configured to refresh cart before open; this opens immediately on ATC
 * and reorders refresh so the drawer slides in while cart data loads.
 */
(function () {
  if (window.__nvCartDrawerPerf) return;
  window.__nvCartDrawerPerf = true;

  var UPCART_POLL_MS = 50;
  var UPCART_POLL_MAX = 160;

  function hasUpcart() {
    return typeof window.upcartOpenCart === 'function';
  }

  function isDrawerCart() {
    return window.themeVariables?.settings?.cartType !== 'page';
  }

  function openCartNow() {
    if (!isDrawerCart()) return;

    if (hasUpcart()) {
      try {
        window.upcartOpenCart();
      } catch (e) {}
      return;
    }

    var drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.open) return;

    if (typeof drawer.show === 'function') {
      try {
        drawer.show();
      } catch (e2) {}
    } else {
      drawer.setAttribute('open', '');
    }
  }

  function isAddToCartForm(form) {
    if (!form || !form.getAttribute) return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function onAtcIntent() {
    openCartNow();
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (!isAddToCartForm(e.target)) return;
      onAtcIntent();
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var btn =
        e.target.closest &&
        e.target.closest(
          'button[name="add"], .buy-buttons button[type="submit"], [data-add-to-cart], .nv-sticky-cta__btn[data-atc="true"]'
        );
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

      var form = btn.form || btn.closest('form');
      if (!isAddToCartForm(form)) return;
      onAtcIntent();
    },
    true
  );

  var polls = 0;
  var upcartTimer = setInterval(function () {
    polls += 1;

    if (!hasUpcart()) {
      if (polls >= UPCART_POLL_MAX) clearInterval(upcartTimer);
      return;
    }

    clearInterval(upcartTimer);

    if (typeof window.upcartSubscribeAddedToCart === 'function') {
      window.upcartSubscribeAddedToCart(function () {
        try {
          window.upcartOpenCart();
        } catch (e) {}
      });
    }

    if (typeof window.upcartRefreshCart === 'function' && !window.__nvUpcartRefreshWrapped) {
      window.__nvUpcartRefreshWrapped = true;
      var origRefresh = window.upcartRefreshCart;

      window.upcartRefreshCart = function () {
        try {
          window.upcartOpenCart();
        } catch (e) {}

        return origRefresh.apply(this, arguments);
      };
    }
  }, UPCART_POLL_MS);

  document.documentElement.addEventListener(
    'cart:change',
    function (e) {
      if (e.detail?.baseEvent !== 'variant:add' || !hasUpcart()) return;

      var drawer = document.getElementById('cart-drawer');
      if (!drawer || !drawer.open) return;

      if (typeof drawer.hide === 'function') {
        drawer.hide();
      } else {
        drawer.removeAttribute('open');
      }
    },
    true
  );
})();
